import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { AuthContext } from './auth-context';

const DashboardContext = createContext(null);

export const DashboardProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  const user = auth?.user;
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursalId, setSelectedSucursalId] = useState(null);

  const selectSucursal = useCallback((id) => {
    setSelectedSucursalId(id);
  }, []);

  useEffect(() => {
    // Evita arrastrar selección/listado de sucursales entre sesiones.
    setSucursales([]);
    setSelectedSucursalId(null);
  }, [user?.personaId, user?.empresaId, user?.EmpresaID]);

  return (
    <DashboardContext.Provider
      value={{ sucursales, setSucursales, selectedSucursalId, selectSucursal }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboard = () => {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard debe usarse dentro de DashboardProvider');
  return ctx;
};
